"use strict";

module.exports = function ($templateContainer, data, templateName) {
	var html = '';

	if (data.status == "maintenance") {
		html += '<div class="alert alert-warning">В текущий момент производится обновление данных системы.'
			+ ' Представленная информация может быть устаревшей.</div>';
	} else if (data.status == "access_denied") {
		$templateContainer.html('<div class="alert alert-danger">У вас не хватает прав для просмотра этой страницы.</div>');
		return;
	} else if (data.status != "success") {
		$templateContainer.html('<div class="alert alert-danger">В работе сервиса произошла ошибка.</div>');
		return;
	}

	//Проверяем наличие типа и меняем содержимое
	if (data.result.type == "program") {
		data.result.name = "Образовательная программа: " + data.result.name;
	} else if (data.result.type == "department") {
		data.result.name = "Кафедра: " + data.result.name;
	}

	data.last_update.documents = humanizeDate(data.last_update.documents);
	data.last_update.umu = humanizeDate(data.last_update.umu);

	var source = $("[data-handlebars-template=" + templateName + "]").html(),
		template = Handlebars.compile(source);

	html += template(data);

	$templateContainer.html(html);

	$(".tooltipped").tooltip({
		selector: "[data-toggle=popover]"
	});

	var $dataTable = $(".data-tables").first();
	$dataTable.DataTable({
		"searching" : true,
		"info" : false,
		"lengthChange" : false,
		"pageLength" : 50,
		"sorting" : false,
		"orderable" : false,
		"ordering" : false,
		"paginate" : true,
		"autoWidth" : false,
		"columnDefs" : [
			{targets : [1, 5], searchable : true},
			{targets : '_all', searchable : false}
		],
		"language" : {
			"zeroRecords" : "Дисциплины не найдены",
			"search" : "Поиск:",
			"paginate" : {
				"first" : "Первая",
				"last" : "Посл.",
				"next" : "След.",
				"previous" : "Пред.",
				"search" : "Поиск:"
			}
		}
	});
	$dataTable.data("dataTableInitialized", true);

	$(".dataTables_paginate").before(' <div class="navigating-pages" js-navigating-pages> <label class="navigating-pages__label"> <input type="text" placeholder="#" class="navigating-pages__field" js-navigating-pages-field> </label> <button type="button" class="btn btn-primary navigating-pages__btn" js-navigating-pages-btn>Перейти</button> </div>')

	if ($(".data-tables tr").length < 51) {
		$(".dataTables_paginate ").hide();
		$(".navigating-pages").hide();
	}

	$('html, body').scrollTop(0);
};

function padLeftZero(string) {
	return '00'.substring(0, 2 - string.toString().length) + string;
}

function humanizeDate(timestamp) {
	var date = new Date(timestamp * 1000);

	return (
		padLeftZero(date.getDate()) + '.' + padLeftZero(date.getMonth() + 1) + '.' + padLeftZero(date.getFullYear())
		+ ' ' + padLeftZero(date.getHours()) + ':' + padLeftZero(date.getMinutes())
	);
}